import { combineReducers } from 'redux';

import auth from './auth';
import user from './user';
import pet from './pet';
import statsbar from './statsbar';
import redemption from './redemption';
import transaction from './transaction';
import media from './media';
import tiers from './member-tiers';
import journey from './journey';
import organization from './organization';
import activity from './activity';
import reward from './reward';
import invoice from './invoice';
import promotion from './promotion';
import product from './product';
import ipwhitelist from './ip-whitelist';
import cms from './cms';
import salesforce from './salesforce-import';
import table from './table';
import settings from './settings';
import authorizedusers from './authorized-users';


const reducer = combineReducers({
  auth,
  user,
  pet,
  statsbar,
  redemption,
  transaction,
  media,
  tiers,
  journey,
  organization,
  activity,
  reward,
  invoice,
  promotion,
  product,
  ipwhitelist,
  cms,
  salesforce,
  table,
  settings,
  authorizedusers,
});

export default reducer;
